<div class="lessons-wrap">
  <h2>Lessons</h2>
  <div class="lesson-list">
    <a class="lesson-card"
       *ngFor="let lesson of lessons"
       [routerLink]="['/guitar-app/lessons', lesson.id]">
      <span class="lesson-level" [class.advanced]="lesson.level === 'Advanced'">{{ lesson.level }}</span>
      <h3 class="lesson-title">{{ lesson.title }}</h3>
      <p class="lesson-summary">{{ lesson.summary }}</p>
    </a>
  </div>
</div>
